var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.026,
    height: 29.026,
    viewBox: "0 0 29.026 29.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f5f9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.644,0H24.382a4.644,4.644,0,0,1,4.644,4.644V24.382a4.644,4.644,0,0,1-4.644,4.644H4.644A4.639,4.639,0,0,1,0,24.385V4.644A4.644,4.644,0,0,1,4.644,0Zm0,2.323A2.326,2.326,0,0,0,2.32,4.647V24.385a2.326,2.326,0,0,0,2.323,2.323H24.382a2.326,2.326,0,0,0,2.323-2.323V4.644A2.326,2.326,0,0,0,24.382,2.32l-19.738,0ZM10.884,20.6H8.153V11.809h2.73ZM9.517,10.611a1.589,1.589,0,1,1,1.582-1.6h0A1.6,1.6,0,0,1,9.517,10.611ZM21.1,20.6H18.377v-4.28c0-1.021-.02-2.326-1.419-2.326-1.419,0-1.637,1.108-1.637,2.254V20.6H12.594V11.809h2.617v1.2h.038a2.864,2.864,0,0,1,2.582-1.419c2.765,0,3.271,1.82,3.271,4.181V20.6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.74224dcd8c0a73eb472e783f62b2ac24.svg";
export { ForwardRef as ReactComponent };